import api from "../../api";

// 0 = Nueva
// 1 = Abierta
// 2 = Asignada
// 3 = En Progreso
// 4 = Cerrada
// 5 = Validada
// 6 = Coordinando Instalacion
// 7 = Registrando Dispositivos
// 8 = Reabierta
// 9 = Cancelada
// 10 = Requiere Actualizacion de Contrator
// 11 = Editando Dispositivos en solicitud
// 12 = Requiere Actualizacion de inventario
// 13 = Require Actualizacion contable
// 14 = Completado
// 15 = Añadio Comentario
// 16 = Re Asginada
// 17 = Sin calificar

const state = {
  status: ""
};

const getters = {};

const actions = {
  create_request: ({ commit }, newRequest) => {
    return new Promise((resolve, reject) => {
      commit("loading");

      api
        .post("/api/serviceRequests", newRequest)
        .then((resp) => {
          commit("success");
          resolve(resp);
        })
        .catch((err) => {
          commit("error");
          reject(err);
        });
    });
  }
};

const mutations = {
  loading: (state) => (state.status = "loading"),
  success: (state) => (state.status = "success"),
  error: (state) => (state.status = "error")
};

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
};
